module.exports = __webpack_public_path__ + "img/logo-mark-sm.97c783dd.png";